import { Api } from './BaseApi'
import { IFeedResult } from '../../types/Feed/IFeedResult';
import { IFeedConfig } from '../../types/Feed/IFeedConfig';

const FeedApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getUserFeed: build.query<IFeedResult, { uid: string, lastId: string }>({
            query: ({ uid, lastId }) => `User/${uid}/Feed?lastId=${lastId}`,
            providesTags: ["GetUserFeed"],
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName;
            },
            // Always merge incoming data to the cache entry
            merge: (currentCache, newItems) => {
                //console.log('merging...', currentCache.FeedItems?.length, newItems.FeedItems?.length, newItems.LastId)
                currentCache.FeedItems.push(...newItems.FeedItems);
                //Limit to 100 items and sort by ID
                currentCache.FeedItems = currentCache.FeedItems.sort((a, b) => b.ID - a.ID).slice(0, 100);
                currentCache.LastId = newItems.LastId;
                currentCache.UnReadCount = currentCache.FeedItems?.filter(x => !x.Is_Read && !(x.Use_Temp_Read && x.Is_Temp_Read)).length;
            },
            // Refetch when the page arg changes
            forceRefetch({ currentArg, previousArg }) {
                //console.log('forceRefetch', currentArg !== previousArg)
                return currentArg !== previousArg;
            }
        }),
        getFeedConfig: build.query<IFeedConfig, string>({
            query: (uid) => `User/${uid}/Feed/Config`,
            providesTags: ["GetFeedConfig"],
        }),
        saveFeedConfig: build.mutation<any, { uid: string, config: IFeedConfig }>({
            query: (info) => ({
                url: `User/${info.uid}/Feed/Config`,
                method: "POST",
                body: info.config
            }),
            async onQueryStarted(info, { dispatch, queryFulfilled }) {
                const postResult = dispatch(
                    FeedApi.util.updateQueryData("getUserFeed", undefined, (draft) => {
                        draft.FeedItems.map(f => f.Is_Read = true);
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    postResult.undo();
                }
            },
            invalidatesTags: ["GetFeedConfig"]
        }),
        resetFeed: build.mutation<any, void>({
            query: () => null,
            async onQueryStarted(info, { dispatch, queryFulfilled }) {
                const postResult = dispatch(
                    FeedApi.util.updateQueryData("getUserFeed", undefined, (draft) => {
                        draft.FeedItems.map(f => {
                            f.Is_Read = f.Use_Temp_Read && f.Is_Temp_Read;
                            f.Use_Temp_Read = false;
                            f.Is_Temp_Read = false;
                            return f;
                        });
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    postResult.undo();
                }
            },
            invalidatesTags: ["GetUserFeed"]
        }),
        clearFeed: build.mutation<any, String>({
            query: (uid) => ({
                url: `User/${uid}/Feed/Clear`,
                method: "POST"
            }),
            async onQueryStarted(info, { dispatch, queryFulfilled }) {
                const postResult = dispatch(
                    FeedApi.util.updateQueryData("getUserFeed", undefined, (draft) => {
                        draft.FeedItems.map(f => {
                            f.Is_Read = true;
                            return f;
                        });
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    postResult.undo();
                }
            },
            invalidatesTags: ["GetUserFeed"]
        }),
        markAsRead: build.mutation<any, { id: number, uid: string }>({
            query: (data) => ({
                url: `User/${data.uid}/Feed/${data.id}/Read`,
                method: "POST"
            }),
            async onQueryStarted(info, { dispatch, queryFulfilled }) {
                const postResult = dispatch(
                    FeedApi.util.updateQueryData("getUserFeed", undefined, (draft) => {
                        var foundIndex = draft.FeedItems.findIndex(f => f.Feed_Item_Id === info.id);

                        console.log('markAsRead', foundIndex, info.id)

                        if (foundIndex > -1) {
                            draft.FeedItems[foundIndex] = { ...draft.FeedItems[foundIndex], Is_Temp_Read: true, Use_Temp_Read: true };
                            draft.UnReadCount = draft.FeedItems?.filter(x => !x.Is_Read && !(x.Use_Temp_Read && x.Is_Temp_Read)).length;
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    postResult.undo();
                }
            },
            invalidatesTags: ["GetUserFeed"]
        }),
        markAsUnRead: build.mutation<any, { id: number, uid: string }>({
            query: (data) => ({
                url: `User/${data.uid}/Feed/${data.id}/UnRead`,
                method: "POST"
            }),
            async onQueryStarted(info, { dispatch, queryFulfilled }) {
                const postResult = dispatch(
                    FeedApi.util.updateQueryData("getUserFeed", undefined, (draft) => {
                        var foundIndex = draft.FeedItems.findIndex(f => f.Feed_Item_Id === info.id);

                        console.log('markAsUnRead', foundIndex, info.id)

                        if (foundIndex > -1) {
                            draft.FeedItems[foundIndex] = { ...draft.FeedItems[foundIndex], Is_Read: false, Is_Temp_Read: false, Use_Temp_Read: false };
                            draft.UnReadCount = draft.FeedItems?.filter(x => !x.Is_Read && !(x.Use_Temp_Read && x.Is_Temp_Read)).length;
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    postResult.undo();
                }
            },
            invalidatesTags: ["GetUserFeed"]
        }),
    }),

    overrideExisting: true,
})

export { FeedApi };